export default __webpack_public_path__ + "static/media/copy_sp.a0148ced.svg";